import { displayUnit } from './uom.js';

// Display label for a base SKU `unit`. Canonical uppercase (ea→EA, box→BOX, bag→BAG,
// ft→FT, can→CAN, tube→TUBE) — one label everywhere a unit is shown to a user (web
// tables, the SKU dialog, the quote PDF, the Telegram bot). The earlier BX/BG
// abbreviations are retired (2026-06-21) in favor of the full canonical set.
// Render-only: the stored enum value is never recased. Delegates to `displayUnit`
// (the canonical UoM source of truth in uom.ts).
export function unitLabel(unit: string | null | undefined): string {
  return displayUnit(unit);
}
